import Anchor, {OpenType} from '@/components/Anchor';
import UserList from '@/components/UserList';
import {ArrowRightSvg, HelpSvg} from '@/icons';
import Icon, {IconSize} from '@/components/Icon';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import classNames from 'classnames';
import {useCallback} from 'react';
import styles from '../index.module.scss';


interface ContributorListProps {
    personalHomeRulesUrl:string;
    docCoinNum: number;
    coinList: any[] | null;
    isMyself: boolean;
    intl: any;
}
const ContributorList: React.FC<ContributorListProps> = (props) => {
    const {docCoinNum, isMyself, intl, personalHomeRulesUrl, coinList} = props;
    const renderInfo = useCallback(() => {
        if (!docCoinNum) {
            return <div className={styles.noCoinInfo}>赠送知识币</div>;
        }
        if (isMyself) {
            return <div className={styles.coinInfo}>
                <span className={styles.coinNum}>
                    {docCoinNum}
                </span>
                ⼈给你赠送了知识币
            </div>;
        }
        return <div className={styles.coinInfo}>
            <span className={styles.coinNum}>
                {docCoinNum}
            </span>
            ⼈赠送了知识币
        </div>;
    }, [docCoinNum, isMyself]);
    return (
        <div className="contributor-list">
            <div className={styles.contentBox}>
                {
                    renderInfo()
                }
                <Tooltip
                    trigger={TooltipTrigger.Hover}
                    content={
                        <div>
                            <div className={styles.giveCoinTipsText}>
                                {intl.formatMessage({id: 'giveCoinTips'})}
                            </div>
                            <div className={styles.ruleDetailBox}>
                                <Anchor
                                    className={styles.ruleDetail}
                                    url={personalHomeRulesUrl}
                                    openType={OpenType.comAndClickOpenNewTab}
                                >
                                    查看详细规则
                                </Anchor>
                                <Icon
                                    className={styles.iconColor}
                                    svg={ArrowRightSvg}
                                    size={IconSize.XXS}
                                    noSpace
                                />
                            </div>
                        </div>
                    }
                >
                    <Icon
                        className={classNames(styles.helpIcon, !docCoinNum && styles.noCoinHelpIcon)}
                        svg={HelpSvg}
                        size={IconSize.SM}
                        noSpace
                    />
                </Tooltip>
            </div>
            {
                !isMyself && !docCoinNum ?
                    <div className={styles.noCoin}>来做第一个送币的同学吧～</div> :
                    <UserList userList={coinList} />
            }
        </div>
    );
};

export default ContributorList;
